/* eslint-disable */

import {useEffect, useState, useRef} from "react";
import MainLayout from "../components/MainLayout";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Dropdown} from "primereact/dropdown";
import {Button} from "primereact/button";
import {toast} from "react-toastify";
import {Calendar} from "primereact/calendar";
import moment from "moment";
import "moment/locale/uz";
import {useNavigate} from "react-router-dom";
import {Edit, Trash} from "lucide-react";
import {Dialog} from "primereact/dialog";
import {
	deleteShipment,
	getDrivers,
	getSborshiks,
	getShipmentFurnitures,
	getShipments,
} from "../services/shipment.service";

const FurnitureReleaseGeneralPage = () => {
	const navigate = useNavigate();
	const baseUrl = `${process.env.REACT_APP_SECOND_URL}/api/v1/gotoviy`;

	// States
	const [showDeleteDialog, setShowDeleteDialog] = useState(false);
	const [deletingShipmentId, setDeletingShipmentId] = useState(null);
	const [first, setFirst] = useState(0);
	const [rows, setRows] = useState(20);
	const [totalRecords, setTotalRecords] = useState(0);

	const [completedShipments, setCompletedShipments] = useState([]);
	const [completedShipmentsArchive, setCompletedShipmentsArchive] = useState(
		[]
	);
	const [isCompletedLoading, setIsCompletedLoading] = useState(false);
	const [shipmentDate, setShipmentDate] = useState(new Date());
	const [availableDrivers, setAvailableDrivers] = useState([]);
	const [availableCollectors, setAvailableCollectors] = useState([]);
	const [availableMagazins, setAvailableMagazins] = useState([]);

	// Shipment filter states
	const [availableShipmentClients, setAvailableShipmentClients] = useState([]);
	const [selectedShipmentClient, setSelectedShipmentClient] = useState(null);
	const [availableShipmentSeries, setAvailableShipmentSeries] = useState([]);
	const [selectedShipmentSerie, setSelectedShipmentSerie] = useState(null);
	const [selectedShipmentDate, setSelectedShipmentDate] = useState(null);
	const [selectedMagazin, setSelectedMagazin] = useState(null);

	// Refs
	const dateInputRef = useRef(null);
	const [updateCounter, setUpdateCounter] = useState(0);

	// Data Fetching
	const fetchDropdownData = async (page = 1) => {
		setIsCompletedLoading(true);
		const shipmentResponse = await getShipments(page);

		const shipments = shipmentResponse.data;
		setTotalRecords(shipmentResponse.total);

		const shipmentsWithFurnitures = await fetchFurnitures(shipments);

		try {
			const [driversRes, collectorsRes] = await Promise.all([
				getDrivers(),
				getSborshiks(),
			]);

			setAvailableDrivers(driversRes);
			setAvailableCollectors(collectorsRes);
			setCompletedShipments(shipmentsWithFurnitures);
			setCompletedShipmentsArchive(shipmentsWithFurnitures);

			setAvailableShipmentClients([
				...new Set(
					shipmentsWithFurnitures.map((value) =>
						value.furnitures[0].demand
							? value.furnitures[0].demand.customer.name
							: console.log(value)
					)
				),
			]);
			setAvailableMagazins([
				...new Set(
					shipmentsWithFurnitures.map(
						(value) => value.furnitures[0].demand.magazin.name
					)
				),
			]);
			setAvailableShipmentSeries(
				[
					...new Set(
						shipmentsWithFurnitures.map((value) =>
							value.furnitures[0].unique?.name.slice(0, 5)
						)
					),
				].filter(Boolean)
			);
		} catch (error) {
			console.error("Failed to fetch dropdown data:", error);
			toast.error("Қўшимча маълумотларни юклашда хатолик");
		} finally {
			setIsCompletedLoading(false);
		}
	};

	const fetchFurnitures = async (shipments) => {
		const furnitureRequests = shipments.map(async (shipment) => {
			const furnitures = await getShipmentFurnitures(shipment.id);
			return {
				shipment,
				furnitures,
			};
		});

		return await Promise.all(furnitureRequests);
	};

	// Effects
	useEffect(() => {
		fetchDropdownData(1);
	}, []);

	// Filter completed shipments based on selected filters
	useEffect(() => {
		const filteredShipments = completedShipmentsArchive?.filter((item) => {
			const matchMagazin = selectedMagazin
				? item.furnitures[0].demand.magazin.name === selectedMagazin
				: true;

			const customerName = item.furnitures[0].demand.customer.name
				? item.furnitures[0].demand.customer.name
				: "";

			const matchClient = selectedShipmentClient
				? customerName === selectedShipmentClient
				: true;

			const orderCode = item.furnitures[0].unique
				? item.furnitures[0].unique?.name.slice(0, 5)
				: null;

			const matchOrder = selectedShipmentSerie
				? orderCode === selectedShipmentSerie
				: true;

			const itemDate = item.shipment.date;
			const matchDate = selectedShipmentDate
				? moment(itemDate).isSame(moment(selectedShipmentDate), "day")
				: true;

			return matchClient && matchDate && matchOrder && matchMagazin;
		});

		setCompletedShipments(filteredShipments);
	}, [
		selectedShipmentClient,
		selectedShipmentSerie,
		selectedShipmentDate,
		selectedMagazin,
		completedShipmentsArchive,
	]);

	// Handlers
	const resetFilters = () => {
		setSelectedShipmentDate(null);
		setSelectedShipmentClient(null);
		setSelectedShipmentSerie(null);
		setSelectedMagazin(null);
	};

	const getDriverNames = (driverIds) => {
		if (!Array.isArray(driverIds)) return "Номаълум";
		const names = driverIds.map((id) => {
			const driver = availableDrivers.find((d) => d.id === id);
			return driver?.name || `ID: ${id}`;
		});
		return names.length > 0 ? names.join(", ") : "Номаълум";
	};

	const getCollectorNames = (collectorIds) => {
		if (!Array.isArray(collectorIds)) return "Номаълум";
		const names = collectorIds.map((id) => {
			const collector = availableCollectors.find((d) => d.id === id);
			return collector?.name || `ID: ${id}`;
		});
		return names.length > 0 ? names.join(", ") : "Номаълум";
	};

	// const renderOrderCode = (rowData) => {
	// 	const orderNo = rowData.demand_furniture?.demand?.doc_no;
	// 	const isHaveId = rowData.demand_furniture_id;
	// 	return !isHaveId ? `Супермаркет` : `${orderNo}`;
	// };

	// Render Helpers
	const renderDateSelector = () => (
		<div>
			<p className="pb-2 text-xl">Сана</p>
			<div className="relative min-w-[12em] border border-gray-300 rounded-md shadow-sm bg-white hover:border-blue-500 focus-within:border-blue-500 focus-within:ring-1 focus-within:ring-blue-500 transition-all duration-200">
				<Calendar
					value={shipmentDate}
					onChange={(e) => {
						setShipmentDate(e.value);
						setSelectedShipmentDate(e.value);
					}}
					className="!w-full calendar-custom"
					dateFormat="dd.mm.yy"
					inputRef={dateInputRef}
					inputClassName="!border-none !shadow-none !outline-none px-3 py-3 w-full text-sm bg-transparent"
					onSelect={() => {
						setTimeout(() => dateInputRef.current?.blur(), 125);
					}}
					showIcon
					iconPos="right"
				/>
			</div>
		</div>
	);

	const renderActions = (rowData) => {
		return (
			<div className="flex items-center gap-3">
				<Edit
					className="text-blue-600 cursor-pointer hover:text-blue-800"
					size={18}
					onClick={() => {
						const editData = completedShipmentsArchive.filter(
							(value) => value.shipment.id === rowData.shipment.id
						);
						console.log(editData);

						navigate(`/customer`, {
							state: {editData: editData, breadCrumb: true},
						});
					}}
				/>
				<Trash
					className="text-blue-600 cursor-pointer hover:text-blue-800"
					size={18}
					onClick={() => {
						setDeletingShipmentId(rowData.shipment.id);
						setShowDeleteDialog(true);
					}}
				/>
			</div>
		);
	};

	const renderGeneralSection = () => (
		<div className="w-full">
			<div className="flex items-center gap-2 mb-5 text-xl text-gray-600 transition hover:text-black">
				<i className="text-lg text-xl pi pi-search" />
				<span className="font-medium">Филтрлар:</span>
				<i
					className="text-lg transition cursor-pointer pi pi-filter-slash hover:text-red-500"
					title="Барчасини тозалаш"
					onClick={resetFilters}
				/>
			</div>

			<div className="flex items-end justify-between gap-4">
				<div className="flex items-end gap-4">
					<div>
						<p className="pb-2 text-xl">Клиент</p>
						<Dropdown
							options={availableShipmentClients}
							onChange={(e) => setSelectedShipmentClient(e.value)}
							placeholder="Клиентни танлаш"
							value={selectedShipmentClient}
							className="w-[12em] border h-[46px] pt-[2px]"
							showClear
							filter
						/>
					</div>
					<div>
						<p className="pb-2 text-xl">Magazin</p>
						<Dropdown
							options={availableMagazins}
							placeholder="Magazin танлаш"
							className="w-[12em] border h-[46px] pt-[2px]"
							onChange={(e) => setSelectedMagazin(e.value)}
							value={selectedMagazin}
							showClear
							filter
						/>
					</div>
					<div>
						<p className="pb-2 text-xl">Seriya nomer</p>
						<Dropdown
							options={availableShipmentSeries}
							onChange={(e) => setSelectedShipmentSerie(e.value)}
							value={selectedShipmentSerie}
							placeholder="Seriya nomer танлаш"
							className="w-[12em] border h-[46px] pt-[2px]"
							showClear
							filter
						/>
					</div>
				</div>
				<div className="flex items-end gap-4">
					<Button
						label="Otgruzka qo'shish"
						className="w-[10em] py-[11px] r-6 text-white rounded-md bg-blue hover:bg-opacity-90"
						onClick={() => navigate(`/customer`, {state: {breadCrumb: true}})}
					/>
					{renderDateSelector()}
				</div>
			</div>
		</div>
	);

	const onPage = async (event) => {
		setFirst(event.first);
		setRows(event.rows);
		await fetchDropdownData(event.first / event.rows + 1);
	};

	return (
		<MainLayout header="ОТГРУЗКАЛАР">
			<div className="">
				{/* Control Panel */}
				<div className="flex justify-between mb-4">
					{renderGeneralSection()}
				</div>

				<DataTable
					className="custom-row-border"
					value={completedShipments}
					loading={isCompletedLoading}
					lazy
					paginator
					rows={rows}
					totalRecords={totalRecords}
					first={first}
					onPage={onPage}
					// rowsPerPageOptions={[5, 10, 20]}
					key={`completed-table-${updateCounter}`}
					emptyMessage="Тугалланган жўнатмалар йўқ">
					<Column header="#" body={(_, {rowIndex}) => rowIndex + 1} />
					<Column
						className="min-w-[170px]"
						header="САНА"
						body={(rowData) =>
							moment(rowData.shipment.date).format("D MMMM YYYY")
						}
					/>
					<Column
						className="min-w-[150px]"
						header="ҚАЕРГА"
						body={(rowData) => rowData.furnitures[0].demand.magazin.name}
					/>
					{/* Супермаркет - yoziladi magazinga ekanligi aniq bo'lsa */}
					<Column
						className="min-w-[230px]"
						header="УНИКАЛ НОМЕР"
						body={(rowData) =>
							rowData.furnitures[0].unique?.name.slice(0, 5) || `-`
						}
					/>
					<Column
						className="min-w-[200px]"
						header="ШАФЁРЛАР"
						body={(rowData) => getDriverNames([rowData.shipment.driver.id])}
					/>
					<Column
						className="min-w-[200px]"
						header="СБОРЩИКЛАР"
						body={(rowData) =>
							getCollectorNames(
								rowData.shipment.sborshiks.map((value) => value.id)
							)
						}
					/>
					<Column
						className="min-w-[120px]"
						header="ТАВСИФ"
						body={(rowData) => rowData.shipment.description}
					/>
					<Column header="ДЕЙСТВИЯ" body={renderActions} />
				</DataTable>
			</div>
			<Dialog
				visible={showDeleteDialog}
				onHide={() => setShowDeleteDialog(false)}
				header={
					<div className="text-lg font-semibold text-black">
						Ушбу юборишни ўчирмоқчимисиз?
					</div>
				}
				className="border-t-[6px] border-red-600 rounded-md shadow-lg"
				style={{width: "30rem"}}
				footer={
					<div className="flex justify-between mt-4">
						<Button
							label="Бекор қилиш"
							icon="pi pi-times"
							className="px-4 py-2 text-black bg-gray-200 hover:bg-gray-300"
							onClick={() => setShowDeleteDialog(false)}
						/>
						<Button
							label="Ўчириш"
							icon="pi pi-trash"
							className="px-4 py-2 text-white bg-red-600 hover:bg-red-700"
							onClick={async () => {
								try {
									await deleteShipment(deletingShipmentId);
									toast.success("Юбориш муваффақиятли ўчирилди");
									fetchDropdownData();
								} catch (error) {
									toast.error("Ўчиришда хатолик юз берди");
								} finally {
									setShowDeleteDialog(false);
								}
							}}
						/>
					</div>
				}
			/>
		</MainLayout>
	);
};

export default FurnitureReleaseGeneralPage;
